/*
  Cart promo bar — "advance" animation.

  The bar is re-rendered from scratch by the Section Rendering API on every cart change,
  so the DOM cannot remember its previous state. This custom element remembers the last
  stage per promo in sessionStorage. When the stage goes UP (a tier was unlocked, or a
  repeat cycle completed and a new one started) the fill is drawn at 100% first, held
  briefly, then shrinks to the new percentage toward the next goal.
*/
if (!customElements.get('cart-promo-bar')) {
  class CartPromoBar extends HTMLElement {
    connectedCallback() {
      const key = 'cart-promo-stage:' + (this.dataset.key || '');
      const stage = parseInt(this.dataset.stage || '0', 10);
      const percent = parseFloat(this.dataset.percent || '0');

      let last = null;
      try {
        last = sessionStorage.getItem(key);
        sessionStorage.setItem(key, String(stage));
      } catch (e) {
        /* storage unavailable: no animation, bar still renders correctly */
      }

      if (last === null || stage <= parseInt(last, 10)) return;

      const fill = this.querySelector('.cart-promo-bar__fill');
      if (!fill || percent >= 100) return;

      fill.style.transition = 'none';
      fill.style.width = '100%';
      this.classList.add('cart-promo-bar--advancing');
      void fill.offsetWidth; // force reflow so the 100% paints before the shrink

      window.setTimeout(() => {
        fill.style.transition = '';
        fill.style.width = percent + '%';
        this.classList.remove('cart-promo-bar--advancing');
      }, 800);
    }
  }
  customElements.define('cart-promo-bar', CartPromoBar);
}
